'use strict';

class FiltersModal extends HTMLElement {
    constructor() {
        super();
        this.openDialog = this.openDialog.bind(this);
    }
    
    connectedCallback() {
        // Find the button and dialog inside this element
        this.button = this.querySelector('button');
        this.dialog = this.querySelector('#filters-dialog');
    
        if (this.button && this.dialog) {
        this.button.addEventListener('click', this.openDialog);
        }
    }
    
    disconnectedCallback() {
        if (this.button) {
        this.button.removeEventListener('click', this.openDialog);
        }
    }
    
    openDialog(event) {
        console.info(event);
        if (this.dialog && typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
        } else if (this.dialog) {
        this.dialog.open = true; // fallback for non-modal dialogs
        }
    }
}
    
customElements.define('filters-modal', FiltersModal);  
